<template>
  <div class="d-inline-flex align-items-center">
    <p class="pr-2 mb-0 pb-0" style="font-size: 18px">{{ batteryPercentage.toFixed(0) }}%</p>
    <div class="battery">
      <div
        :class="[batteryWarnAlert]"
        class="battery-level"
        :style="{ width: batteryPercentage + 1 + '%' }"
      ></div>
    </div>
    <div class="ml-2">
      <svg-icon v-show="charging" size="18" name="zap" class="fill-icon mr-2 icon-light"></svg-icon>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BoxInfoBattery',
  props: {
    value: Number,
    charging: Number,
  },
  computed: {
    batteryPercentage() {
      return this.value == -1 ? 0 : this.value;
    },
    batteryWarnAlert() {
      return this.batteryPercentage > 20
        ? ''
        : this.batteryPercentage < 21 && this.batteryPercentage > 10
        ? 'bg-warning'
        : 'bg-danger';
    },
  },
};
</script>

<style>
.bigIcon {
  font-size: 22px;
}
.battery {
  border: 1px solid gray;
  width: 40px;
  height: 17px;
  border-radius: 6px;
  position: relative;
}
.battery:after {
  content: '';
  height: 5px;
  width: 1px;
  background: gray;
  right: -3px;
  top: 5px;
  border-radius: 10px 10px 0 0;
  position: absolute;
}

.battery-level {
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  height: 100%;
  border: 2px solid #191c24;
  border-radius: 5px;
}
.battery-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: white;
  mix-blend-mode: hard-light;
  font-size: 15px;
  text-align: center;
}
</style>
